// The message id for an API error body ({ response: "<CODE>", ... }): the
// lower-cased code when there is a message for it (for example
// ENTERPRISE_INACTIVE), otherwise the general message ("Unknown Error", or
// the id a screen passes as fallbackId), so a code without a message never
// shows as its raw id.
export const errorMessageId = (error, intl, fallbackId = "unknown_error") => {
  const id = String(error?.response || "").toLowerCase();
  return id && intl?.messages?.[id] ? id : fallbackId;
};

// An error answer's body as an object. A request made for a file
// (responseType "blob") gets its error body as a Blob as well, which has to
// be read before its code can be seen; anything unreadable is {}.
export const readErrorBody = async (data) => {
  if (typeof Blob !== "undefined" && data instanceof Blob) {
    try {
      const text = data.text
        ? await data.text()
        : await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = () => reject(reader.error);
            reader.readAsText(data);
          });
      const body = JSON.parse(text);
      return body && typeof body === "object" ? body : {};
    } catch {
      return {};
    }
  }
  return data && typeof data === "object" ? data : {};
};

// The code of the API's 429 answer over a rate limit (F21). Its body carries
// the wait in whole minutes (retryAfterMinutes).
export const TOO_MANY_ATTEMPTS = "TOO_MANY_ATTEMPTS";

// The text to show for an API error body: "Too many attempts, try again in N
// minutes" over a rate limit, otherwise the message of errorMessageId.
export const errorText = (error, intl, fallbackId = "unknown_error") => {
  if (error?.response === TOO_MANY_ATTEMPTS) {
    const minutes = Math.ceil(Number(error?.retryAfterMinutes));
    return intl.formatMessage(
      { id: "too_many_attempts" },
      { minutes: Number.isFinite(minutes) && minutes > 0 ? minutes : 1 }
    );
  }
  return intl.formatMessage({ id: errorMessageId(error, intl, fallbackId) });
};
